Browser = require '@trello/browser'
{ track } = require '@trello/analytics'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
{ Storage } = require '@trello/storage'
t = require('app/scripts/views/internal/teacup-with-helpers')('browser_will_be_unsupported')

LAST_DISMISSED_STORAGE_KEY = 'unsupportedBrowserBannerLastDismissed'

template = t.renderable ->
  t.p '.u-bottom.js-message', ->
    switch Browser.browserStr
      when 'explorer'
        t.format 'trello-is-ending-support-for-ie'
        t.text ' '
        t.format 'please-use-edge-or-the-desktop-client', {
          edge: 'https://support.microsoft.com/en-us/help/12435/windows-10-upgrade-faq',
          desktop: 'https://trello.com/platforms'
        }

      when 'safari'
        t.format 'this-version-of-safari-is-not-supported'
        t.text ' '
        t.format 'please-upgrade-to-a-supported-version', {
          url: 'https://support.apple.com/downloads/safari'
        }

      when 'chrome'
        t.format 'this-version-of-chrome-is-not-supported'
        t.text ' '
        t.format 'please-upgrade-to-a-supported-version', {
          url: 'https://www.google.com/chrome'
        }

      when 'edge'
        t.format 'this-version-of-edge-is-not-supported'
        t.text ' '
        t.format 'please-upgrade-to-a-supported-version', {
          url: 'https://www.microsoft.com/en-us/windows/microsoft-edge'
        }

      when 'firefox'
        t.format 'this-version-of-firefox-is-not-supported'
        t.text ' '
        t.format 'please-upgrade-to-a-supported-version', {
          url: 'https://www.firefox.com/'
        }

      else
        # They're using a browser we don't recognize e.g. Vivaldi
        t.format 'this-browser-is-not-supported'
        t.text ' '
        t.format 'you-may-need-to-upgrade-or-switch-to-a-supported-browser'

  t.a '.icon-lg.icon-close.js-close-banner', { href: '#' }

module.exports = class BrowserWillBeUnsupportedView extends WarningBannerView
  className: 'header-banner mod-warning unsupported-browser-banner'

  events:
    'click .js-message > a': (e) ->
      track("Unsupported Browser Banner", "Clicked Upgrade", Browser.browserVersionStr)

    'click .js-close-banner': (e) ->
      track("Unsupported Browser Banner", "Clicked Hide", Browser.browserVersionStr)
      now = new Date().toISOString()
      Storage.set(LAST_DISMISSED_STORAGE_KEY, now)
      @render()

  render: ->
    lastDismissed = Storage.get(LAST_DISMISSED_STORAGE_KEY)

    if lastDismissed
      # Hide the banner if it was dismissed less than a week ago
      now = new Date()
      dateLastDismissed = new Date(lastDismissed)
      isHidden = now - dateLastDismissed < (7 * 24 * 60 * 60 * 1000)
    else
      isHidden = false

    if !isHidden
      track("Unsupported Browser Banner", "Displayed", Browser.browserVersionStr)

    @$el.toggleClass('hide', isHidden)
    @$el.html(template())
    @
